export const GET_MAILING = 'GET_MAILING';
export const GET_MAILING_SUCCESS = 'GET_MAILING_SUCCESS';
export const GET_MAILING_FAIL = 'GET_MAILING_FAIL';

export const ADD_MAILING = 'ADD_MAILING';
export const ADD_MAILING_SUCCESS = 'ADD_MAILING_SUCCESS';
export const ADD_MAILING_FAIL = 'ADD_MAILING_FAIL';
export const ADD_MAILING_CLEAR = 'ADD_MAILING_CLEAR';
